// src/theme.js
import { createTheme } from "@mui/material/styles";
import "@fontsource/ibm-plex-sans-condensed";

const theme = createTheme({
  palette: {
    primary: { main: "#1198a1" },
    secondary: { main: "#9c27b0" },
    error: { main: "#c40d68" },
    warning: { main: "#c57112" },
    info: { main: "#1196d3" },
    success: { main: "#1198a1" },
    background: {
        default: "#f5f5f5",
        paper: "#ffffff",
    },
    text: {
        primary: "#000000",
        secondary: "#666666",
    },
    divider: "#e0e0e0",
  },
  typography: {
    fontFamily: "IBM Plex Sans Condensed, sans-serif",
    h1: { fontSize: "3rem", fontWeight: 300, lineHeight: "3.2rem", marginTop: "0.5rem" },
    h2: { fontSize: "2rem", fontWeight: 300, lineHeight: "2.2rem", marginTop: "0.5rem" },
    h3: { fontSize: "1.7rem", fontWeight: 400, lineHeight: "1.9rem", marginTop: "0.5rem" },
    h4: { fontSize: "1.5rem", fontWeight: 600, lineHeight: "1.7rem", marginTop: "0.5rem" },
    h5: { fontSize: "1.3rem", fontWeight: 600, lineHeight: "1.5rem", marginTop: "0.5rem" },
    h6: { fontSize: "1.2rem", fontWeight: 600, lineHeight: "1.4rem", marginTop: "0.5rem" },
    body1: { fontSize: "1.2rem", fontWeight: 400, lineHeight: "1.4rem", marginTop: "0.5rem" },
    body2: { fontSize: "1rem", fontWeight: 400, lineHeight: "1.2rem", marginTop: "0.5rem" },
  },

  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#1198a1",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
        //   textTransform: "none", // no ALL CAPS
          borderRadius: 4,
          fontSize: "1.0rem"
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
            margin: 0, 
            borderRadius: 8,
            width: "95%",
            maxWidth: "500px",
            maxHeight: '95%',
            padding: 2
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1.25rem',
          lineHeight: '1.25rem',
          marginTop: "0rem",
          fontWeight: 700,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        dividers: {
          borderTop: '1px solid',
          borderBottom: '1px solid',
          borderColor: '#D3D3D3',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0, // remove default padding
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: 4,
          paddingBottom: 4,
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
            marginTop: 0,
            marginBottom: 0,
        },
        secondary: {
            marginTop: 0,
            marginBottom: 0,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '32px', // default is 56px, reduce it here
          marginRight: '12px', // adjust spacing between icon and text
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: 4, // remove default padding
        },
      },
    },
    MuiListSubheader: {
        styleOverrides: {
            root: {
                color: "#000000",
                fontWeight: 700, 
                fontSize: '1.2rem',
                paddingTop: '0px',
                paddingBottom: '0px',
            },
        },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
            marginTop: 0,
            marginBottom: 0,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
            minHeight: 'unset',
            py: 1.1,
            px: 2,
            fontSize: '1.2rem'
        },
      },
    },
  },
});

export default theme;
